import React from 'react';

import './style.css';

interface Props {
  oncancel?: () => void,
  onsubmit?: (event?: React.FormEvent) => void
}


const AuthBtnsComponent: React.FC<Props> = ({oncancel, onsubmit}) => {
  return (
    <div className='flex js-sbw pos-rel auth-btn-wrapper'>
      {
        onsubmit && <button className='auth-btn'
                            id='submit-btn'
                            onClick={onsubmit}
                            title='Click to Log In'
                            type='button'
        >Login</button>
      }
      {
        oncancel && <button className='auth-btn'
                            id='cancel-btn'
                            onClick={oncancel}
                            title='Click to Cancel'
                            type='button'
        >Cancel</button>
      }
    </div>
  )

};

export default AuthBtnsComponent